module.exports = __webpack_public_path__ + "assets/img/5.9bcfb19f.png";